import * as React from "react";
import { ChatInput } from "@/components/chat/ChatInput";
import { usePromptGeneratorContext } from "@/components/feature/promptGenerator/hooks";
import { useCurrentPdf } from "@/modules/chat/hooks/useCurrentPdf";

interface Props {
  onSendMessage: (message: string) => void;
  isStreaming: boolean;
  isReady: boolean;
  onCancel?: () => void;
}

export const MessageInput = React.memo(({ onSendMessage, isStreaming, isReady, onCancel }: Props) => {
  const { setRightDrawerContent } = useCurrentPdf();
  const { promptToChat, sendPromptToChat } = usePromptGeneratorContext();

  React.useEffect(() => {
    if (promptToChat) {
      setRightDrawerContent("promptGenerator");
      onSendMessage(promptToChat);
      sendPromptToChat(null);
    }
  }, [promptToChat, onSendMessage, setRightDrawerContent, sendPromptToChat]);

  return (
    <ChatInput
      onSendMessage={onSendMessage}
      isStreaming={isStreaming}
      isReady={isReady}
      placeholder="Type your message here..."
      compact
      onCancel={onCancel}
    />
  );
});
